/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import React from 'react';

import { getComponentFromName } from '../../../lib/utils';

import { useTheme } from '../../../contexts/ThemeContext';
import * as Components from './index';

const propTypes = {
    component: PropTypes.string.isRequired,
};

const defaultProps = {};

function Step({ component, ...props }) {
    const { name, variant = null } = useTheme();
    const Component =
        (variant || []).reduce(
            (acc, v) => acc || getComponentFromName(Components, `${v}-${component}`, null),
            null,
        ) ||
        getComponentFromName(Components, `${name}-${component}`, null) ||
        getComponentFromName(Components, component, null) ||
        null;
    // eslint-disable-next-line react/jsx-props-no-spreading
    // console.log('component', Component, name, variant);
    return Component !== null ? <Component {...props} /> : null;
}

Step.propTypes = propTypes;
Step.defaultProps = defaultProps;

export default Step;
